<template>
  <div class="w-100 table-responsive">
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-default">
    </base-header>
    <b-container fluid class="mt--7">
      <b-row>
        <b-col cols="12">
          <b-card class="table-responsive">
            <b-card-header class="border-0 d-flex justify-content-between">
              <h3 class="mb-0">Detalle del tickets</h3>
              <h3 v-if="ticket">Solucionado: {{ticket.isSolved ? "SI": "NO"}}</h3>
            </b-card-header>
            <div class="row">
              <div class="col-lg-6" v-if="ticket">
                <h5>Asunto:</h5>
                <span>{{ticket.subject}}</span>
                <h5>Mensaje:</h5>
                <span>{{ticket.body}}</span>
                <hr>
                <h5>Respuestas: </h5>
                <div class="w-100 d-flex justify-content-between" v-for="(item, index) in ticket.answers" :key="index">
                  <p v-html="item.answer" :style="{'color': isMe(item)? '#172b4d':'red'}" class="pb-0 mb-0"></p>
                  <p :style="{'color': isMe(item)? '#172b4d':'red'}" class="pb-0 mb-0">{{item.created_at |formatDate}}</p>
                </div>
              </div>
              <div class="col-lg-6">
                <ckeditor v-model="ticket_response"></ckeditor>
                <button class="btn btn-primary btn-block" @click="replyTicket">GUARDAR</button>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {get, post} from "@/util/axiosRequest";
import {decrypt} from "@/util/encrypt";

export default {
  name: "Detail",
  data: () => ({
    ticket: null,
    ticket_id: null,
    ticket_response: null,
    admin_id: null
  }),
  mounted() {
    this.ticket_id = this.$route.query.id
    this.getTicket()
    const admin = localStorage.getItem("oanda-user-admin-am")
    const dec = decrypt(admin)
    const user = JSON.parse(dec)
    this.admin_id = user.uid
  },
  methods: {
    async getTicket(){
      const {data} = await get(`support/view?id=${this.ticket_id}`,null, true)
      this.ticket = data[0]
    },
    async replyTicket() {
      if(this.ticket_response){
        await post("support/answer", {answer: this.ticket_response,support_id: this.ticket_id, isSolved: true }, true)
        this.ticket_response = null
        this.getTicket()
      }
    },
    isMe(message) {
      return this.admin_id === message.user_id;
    },
  }
}
</script>

<style scoped>

</style>
